const translations = {
    fetchingUserRolesError: 'Error fetching user roles',
    updatingUserRolesSuccess: 'User roles updated successfully'
};

export default translations;
